import util from '../utils/util';
import { COOKIE_DURATION } from '../constans';
import { urlDomodi, urlAllani } from '../api';
import { domodiTransactionMapper, allaniTransactionMapper } from '../utils/transactionMapper';
import logger from '../utils/logger';

const eCommerce = Object.freeze({
    events: {
        Purchase(data, cookies) {
            const transactionSignature = this.common.generateTransactionSignature.call(this, data);

            if (!util.getCookie(transactionSignature)) {
                this.common.createPixel.call(this, data);

                if (!this.blockLegacyRequest) {
                    if (cookies.domodi.id) {
                        this.common.createPixel.call(
                            this,
                            domodiTransactionMapper(cookies, data),
                            urlDomodi
                        );
                    }

                    if (cookies.allani.id) {
                        this.common.createPixel.call(
                            this,
                            allaniTransactionMapper(cookies, data),
                            urlAllani
                        );
                    }
                }

                if (!this.blockTransactionSignature) {
                    util.setCookie(transactionSignature, true, COOKIE_DURATION);
                }
            } else {
                logger.warn('Transaction already sent.');
            }
        },
        Conversion: {},
        ViewContent: {},
        AddToCart: {},
        CustomEvent: {},
        PageView: {},
        ViewPage: {},
        UserCreated: {}
    },
    content: {
        value: {
            type: Number
        },
        id: {
            type: String
        },
        shipping_cost: {
            type: Number
        },
        discount_code: {
            type: String
        },
        in_stock: {
            type: Boolean
        },
        name: {
            type: String
        },
        currency: {
            type: String
        },
        ean: {
            type: String
        },
        sizes: {
            type: Array
        },
        quantity: {
            type: Number
        },
        transaction_id: {
            type: String
        },
        content_ids: {
            type: Array
        },
        content_type: {
            type: String
        },
        content_category: {
            type: String
        },
        content_category_id: {
            type: String
        }
    }
});

export default eCommerce;
